import { useMutation, useQueryClient } from "@tanstack/react-query";
import useSelectedStores from "@lib/hooks/use-selected-stores";
import type { Dashboard } from "@lib/types/dashboards";
import {
  createDashboardWithReorderedInsights,
  invalidateDashboardQueries,
  updateDashboardOnServer,
} from "./utils";

export function useReorderDashboardInsights() {
  const queryClient = useQueryClient();
  const { selectedOrganisation } = useSelectedStores();

  return useMutation({
    mutationFn: async ({
      dashboard,
      newInsightIds,
    }: {
      dashboard: Dashboard;
      newInsightIds: string[];
    }) => {
      if (!selectedOrganisation) {
        throw new Error("Organisation ID is required");
      }

      return updateDashboardOnServer(
        selectedOrganisation,
        dashboard.id,
        createDashboardWithReorderedInsights(dashboard, newInsightIds)
      );
    },
    onSuccess: async (updatedDashboard) => {
      await invalidateDashboardQueries(
        queryClient,
        selectedOrganisation,
        updatedDashboard.id
      );
    },
  });
}
